import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

export enum LegendPositionEnum {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

const LayoutStyle = (props: { layout: LegendPositionEnum }) =>
  props.layout === LegendPositionEnum.horizontal
    ? css`
        display: flex;
        font-size: 12px;
        color: #566072;
        align-items: center;
      `
    : css`
        display: flex;
        font-size: 12px;
        color: #566072;
        flex-direction: column;
      `;

const ChartLegendContainer = styled.div`
  ${LayoutStyle}
  height: 14px;
`;

const LegendCircle = styled.div<ColorStyleProps>`
  height: 15px;
  width: 15px;
  background-color: ${(s: ColorStyleProps) => s.color};
  border-radius: 50px;
  display: inline-flex;
  margin-right: 5px;
  justify-self: center;
  align-self: center;
`;

const ChartLegendItem = styled.div`
  display: flex;
  align-items: center;
  height: 16px;
  margin-left: 32px;
  &:first-of-type {
    margin-left: 0;
  }
  & > span {
    padding-top: 1px;
  }
`;

interface ColorStyleProps {
  color: string;
}

interface Props {
  legendItems: { color: string; label: string }[];
  position?: LegendPositionEnum; // default is horizontal
}

export const ChartLegend = (props: Props) => {
  const legendLayout = props.position ? props.position : LegendPositionEnum.horizontal;
  return (
    <ChartLegendContainer layout={legendLayout}>
      {props.legendItems.map((d: { color: string; label: string }, i: number) => {
        const color = d.color;
        const label = d.label;
        return (
          <ChartLegendItem key={i}>
            <LegendCircle color={color} />
            <span>{label}</span>
          </ChartLegendItem>
        );
      })}
    </ChartLegendContainer>
  );
};

export default ChartLegend;
